import React, { useEffect, useState } from "react";
import "./LoginPage.scss";
import axios from 'axios';
import { Spin } from "antd";
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import wait_img from "../images/gif/loader.gif";
import { routesPaths } from "../routing/routesPaths";
import { SSO_CODE, DASHBOARD_BFF_LOGIN, DASHBOARD_BFF_CHANGE_PASSWORD_API, DASHBOARD_BFF_SSO_LOGIN, APP_SECURITY_TOKEN, ENV, LOGIN_APP_ID } from '../utils/api';


const LoginPage = (props) => {
    const {t} = props;
    //const {code} = props;
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);
    const [otp, setOtp] = useState(null);
    const [newPassword, setNewPassword] = useState(null);
    const [repeatPassword, setRepeatPassword] = useState(null);
    const [setUpPassword, setSetUpPassword] = useState(false);
    //const { v4: uuidv4 } = require('uuid');

    const loginData = {
        username: username,
        password: password,
        otp: otp,
        app_id: LOGIN_APP_ID !== 'DEFAULT' ? LOGIN_APP_ID : null
    };

    function getCookieValue(cookieName) {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [key, value] = cookie.trim().split('=');
            if (key === cookieName) {
                return decodeURIComponent(value); // Decodifica il valore per gestire caratteri speciali
            }
        }
        return null; // Ritorna null se il cookie non esiste
    }

    useEffect(() => {
        if (ENV === "LOCAL") {
            // Logica per l'ambiente LOCAL
            sessionStorage.setItem("enabledModules", "SDD,SCT,MANDATE,PAY,CREDIT,WALLET,CONFIG,USERS,BILLING,CUSTOMER,VOPCHECK,CHATBOT,COMMISSIONS,RECONCILIATION,SCTCB");
            sessionStorage.setItem("enabledFunctions", "0201,0202,0303,0401,0604,0701,0702,0703,0704,0705,0706,0707,0708,0709,0710,1001,1002,1003,1101,1102,1103,0501,0502,0503,0504,0505,0506,0507,0508,0509");
            sessionStorage.setItem("username", "developer");
            sessionStorage.setItem("email", "developer@nttdata.com");
            sessionStorage.setItem("appId", "D0000000001");
            sessionStorage.setItem("sessionTimeout", 30 * 60 * 1000);

            addCommissionsMock();
            window.location.replace(routesPaths.paymentGatewayStatistics);

        } else if (ENV === "DEV") {
            // Verifica se il code è valorizzato
            const savedCode = getCookieValue('code');
            addCommissionsMock();

            if (savedCode) {
                ssoLogin(savedCode); // Esegui la login SSO con il code
            }
        } else {
            // Logica per tutti gli altri ambienti
            const savedCode = getCookieValue("code");
            if (savedCode) {
                ssoLogin(savedCode); // Login SSO se il code è valorizzato
            } else {
                redirectToSSO(); // Altrimenti, reindirizza all'URL SSO
            }
        }
    }, []);

    function redirectToSSO() {
        const urlWithSessionCode = SSO_CODE; // uuidv4 genera un ID univoco
        window.location = urlWithSessionCode;
    }
    function deleteCookie(name) {
    document.cookie = `${name}=; Path=/; Max-Age=0; Secure; SameSite=Strict`;
    }
    async function ssoLogin(code) {
        try {
            setLoading(true);
            const data = JSON.stringify({ code });
            const config = {
                method: "POST",
                url: DASHBOARD_BFF_SSO_LOGIN,
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Application-Token': APP_SECURITY_TOKEN
                },
                params: { owner: LOGIN_APP_ID },
                data
            };
            const response = await axios.request(config);
            console.log("Risposta completa:", response);
            const result = response.data;
            sessionStorage.setItem("username", result.username);
            sessionStorage.setItem("email", result.email);
            sessionStorage.setItem("enabledModules", result.modulesEnabled);
            sessionStorage.setItem("enabledFunctions", result.functionsEnabled);
            sessionStorage.setItem("appId", result.appId);
            sessionStorage.setItem("sessionTimeout", 30 * 60 * 1000);
            deleteCookie("code");
            deleteCookie("state");
            deleteCookie("session_state");
            window.location.replace(routesPaths.paymentGatewayStatistics);
        } catch (error) {
            console.error("Errore durante il login SSO:", error);
            redirectToSSO(); // Reindirizza nuovamente all'SSO se qualcosa fallisce
        } finally {
            setLoading(false);
        }
    }

    async function loginAuth() {
        setLoading(true);
        if ( !username || !password || !otp ) {
            alert(t("error.fillInLoginFormFirst", {ns: "messages"}));
        } else {
            await axios({
                url: DASHBOARD_BFF_LOGIN,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Application-Token": APP_SECURITY_TOKEN 
                },
                data: JSON.stringify(loginData)
            }).then((response) => {
                sessionStorage.setItem("enabledModules", response.data.modulesEnabled);
                sessionStorage.setItem("enabledFunctions", response.data.functionsEnabled);
                sessionStorage.setItem("username", response.data.username);
                sessionStorage.setItem("email", response.data.email);
                sessionStorage.setItem("appId", response.data.appId);
                sessionStorage.setItem("sessionTimeout", 30 * 60 * 1000);

                if(response.data.email === "francesco.barbuto@emeal.nttdata.com"){
                    window.location.replace(routesPaths.usersStatistics);
                }else{
                    window.location.replace(routesPaths.paymentGatewayStatistics);
                }
            }).catch((error) => {
                console.log(error.response.status);
                console.log(error.response.data.messages[0].message);
                if(error.response.data.messages[0].message === "Account is not fully set up" && error.response.status === 400){
                    alert("Please set your password");
                    setOtp(null);
                    setSetUpPassword(true);
                }else{
                    const s401 = error.response && error.response.status === 401 && 401;
                    if (s401) {
                        alert("Auth failed");
                    } else {
                        alert("Service unavailable" + ": " + error.response);
                    }
                }
            })
        }
        setLoading(false);
    }
    
    /*
    async function loginAuth() {
        setLoading(true);
        if (username === "demo@emeal.nttdata.com" && password === "Agosto2024!") {
            await wait(1500); // Simula un delay per la risposta
            sessionStorage.setItem("enabledModules", "SDD,SCT,MANDATE,PAY,CREDIT,WALLET,CONFIG,USERS,CUSTOMER,BILLING,VOPCHECK,CHATBOT");
            sessionStorage.setItem("enabledFunctions", "0201,0202,0303,0701,0702,0703,0704,0705,0706,0707,0708,0709,0710");
            sessionStorage.setItem("username", "demo_user");
            sessionStorage.setItem("email", username);
            sessionStorage.setItem("appId", "D0000000001");
            window.location.replace(routesPaths.paymentGatewayTransactions);
        } else {
            console.log("Auth failed");
        }
        setLoading(false);
    }
    */

    function addCommissionsMock(){
        const commissionProductDataMock = [
                {
                    id: "product-1",
                    name: "SCT SEPA",
                    description: "Bonifico SEPA SCT",
                    attributes: [
                        {
                            name: "importo",
                            description: "importo dell'operazione",
                            type: "integer"
                        },
                        {
                            name: "canale",
                            description: "canale di origine dell'operazione",
                            type: "string"
                        }
                    ]
                }
            ,
                {
                    id: "product-2",
                    name: "SDD SEPA",
                    description: "Bonifico SEPA SDD",
                    attributes: [
                        {
                            name: "importo",
                            description: "importo dell'operazione",
                            type: "integer"
                        },
                        {
                            name: "canale",
                            description: "canale di origine dell'operazione",
                            type: "string"
                        }
                    ]
                }
            ];

        const commissionDataMock = [
                {
                    id: "commission-1",
                    name: "Commissione SCT",
                    description: "Esecuzione SCT - Importo Fisso",
                    unit: "FISSO",
                    value: "1",
                    product: "product-1",
                    start_date: "01/06/2025",
                    end_date: "04/06/2025",
                    rules: [ 
                        {
                            conditions: [
                                {
                                    name: "importo",
                                    operator: "<",
                                    value: "1000"
                                },
                                {
                                    name: "canale",
                                    operator: "=",
                                    value: "online"
                                }
                            ]
                        },
                        {
                            conditions: [
                                {
                                    "name": "importo",
                                    "operator": "<",
                                    "value": "5000"
                                },
                                {
                                    name: "canale",
                                    operator: "=",
                                    value: "batch"
                                }
                            ]
                        }
                    ]
                }
            ];
        const commissionUnitListMock = ["FISSO","PERCENTUALE"];
        const commissionsChannelOptions = ["online", "batch"];


        const voucherCampaignsMock = [
            {
                id: "campaign-1",
                codePrefix: "WELCOME",
                value: 10,
                totalVouchers: 2,
                start_date: "01/06/2025",
                end_date: "04/06/2025",
                status: "CONCLUSA"
            }
        ];

        const vouchersMock = [
            {
                id: "voucher-1",
                campaignId: "campaign-1",
                code: "WELCOME-RETHSD-WESLCK",
                value: 10,
                userId: "user-123",
                status: "UTILIZZATO"
            },
            {
                id: "voucher-2",
                campaignId: "campaign-1",
                code: "WELCOME-OSIEMA-FPVEJA",
                value: 10,
                userId: "user-456",
                status: "SCADUTO"
            }
        ];

        sessionStorage.setItem("commissionProductDataMock",JSON.stringify(commissionProductDataMock));
        sessionStorage.setItem("commissionDataMock",JSON.stringify(commissionDataMock));
        sessionStorage.setItem("commissionUnitListMock",JSON.stringify(commissionUnitListMock));
        sessionStorage.setItem("commissionChannelListMock",JSON.stringify(commissionsChannelOptions));
        sessionStorage.setItem("voucherCampaignsMock",JSON.stringify(voucherCampaignsMock));
        sessionStorage.setItem("vouchersMock",JSON.stringify(vouchersMock));
    }

    function handleFormInputs(e, id) {
        if (id === "username") {
            setUsername(e.target.value);
        }
        if (id === "password") {
            setPassword(e.target.value);
        }
        if (id === "otp") {
            setOtp(e.target.value);
        }
        if (id === "newPassword") {
            setNewPassword(e.target.value);
        }
        if (id === "repeatPassword") {
            setRepeatPassword(e.target.value);
        }
    }

    function handleEnterKeyPress(event) {
        if (event.key === "Enter") {
            loginAuth();
        }
    }

    function wait(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    function setUpNewPassword() {
        if (newPassword === repeatPassword) {
            setLoading(true);
            var axios = require('axios');

            const encodedOldPassword = Buffer.from(password).toString('base64');
            const encodedPassword = Buffer.from(newPassword).toString('base64');

            var config = {
                method: 'PUT',
                url: `${DASHBOARD_BFF_CHANGE_PASSWORD_API}?username=${username}&oldPassword=${encodedOldPassword}&password=${encodedPassword}&otp=${otp}`,
                headers: {
                    'accept': 'application/json',
                    'X-Application-Token': APP_SECURITY_TOKEN
                }
            };

            axios(config).then(function (response) {
                setSetUpPassword(false);
                alert("Password update success");
                setLoading(false);
            }).catch(function (error) {
                console.log(error);
                setLoading(false);
            });
        } else {
            alert("You have entered different passwords!");
        }
    }

    return (
        <div>
            {ENV !== "DEV" &&
                <Spin spinning={loading} indicator={<img src={wait_img} style={{ width: 80, height: 80 }} />} />
            }
            {ENV === "DEV" &&
                <div className="login-page" style={{ borderRadius: "5px", backgroundColor: "#3e5364" }}>
                    {/*<img src={banner} alt="logo" />*/}
                    <div className="login-page_form-container" >
                        {/*<img width="350px" height="164px" src={logo} alt="logo" />*/}
                        {!setUpPassword &&
                            <Grid container
                                style={{ marginTop: "20px", backgroundColor: "#FFFFFF", borderRadius: "5px", paddingRight: "7px", paddingBottom: "8px" }}
                                spacing={1}
                                direction="column"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Grid container item xs={12}>
                                    <TextField fullWidth id="outlined" label="Username" variant="outlined" onChange={(e) => handleFormInputs(e, "username")} onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12}>
                                    <TextField fullWidth
                                        type="password"
                                        id="outlined-password-input"
                                        label="Password"
                                        variant="outlined"
                                        onChange={(e) => handleFormInputs(e, "password")}
                                        onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12}>
                                    <TextField fullWidth
                                        type="password"
                                        id="outlined-password-input"
                                        label="otp"
                                        variant="outlined"
                                        onChange={(e) => handleFormInputs(e, "otp")}
                                        onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12} justifyContent="center" alignItems="center">
                                    {loading ? (
                                        <Spin spinning={loading} indicator={<img src={wait_img} style={{ width: 80, height: 80 }} />} />
                                    ) : (
                                        <Button variant="contained" onClick={loginAuth} fullWidth style={{ backgroundColor: "#024979", color: "#ffffff", fontSize: "14px", letterSpacing: "1px" }}>
                                            <b>LOGIN</b>
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                        }{setUpPassword &&
                            <Grid container
                                style={{
                                    marginTop: "20px",
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: "5px",
                                    paddingRight: "7px",
                                    paddingBottom: "8px"
                                }}
                                spacing={1}
                                direction="column"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Grid container item xs={12}>
                                    <TextField fullWidth type="password" id="outlined-password-input" label="Password" variant="outlined"
                                        onChange={(e) => handleFormInputs(e, "newPassword")} onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12}>
                                    <TextField fullWidth type="password" id="outlined-password-input" label="Repeat Password" variant="outlined"
                                        onChange={(e) => handleFormInputs(e, "repeatPassword")} onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12}>
                                    <TextField fullWidth type="password" id="outlined-password-input" label="otp"
                                        variant="outlined" onChange={(e) => handleFormInputs(e, "otp")} onKeyPress={handleEnterKeyPress} />
                                </Grid>
                                <Grid container item xs={12}>
                                    <Button variant="contained" loading={loading.toString()} onClick={setUpNewPassword} fullWidth
                                        style={{ backgroundColor: "#FFBB4D", color: "#323234", fontSize: "14px", letterSpacing: "1px" }}
                                    >
                                        <b>Set Up Password</b>
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                    </div>
                </div>
            }
        </div>
    )
};

export default LoginPage;